import { isWeddingDressProperty } from '@merchant-backend/util'
import { isEmojiCharacter } from '@util'

export const validatorCoverPath = (rule, value, callback) => {
  if (!value) {
    callback('请上传案例封面')
    return
  }
  if (!value.cover_img || !value.cover_img.href) {
    callback('请上传横图')
    return
  }
  if (!value.up_cover_img || !value.up_cover_img.href) {
    callback(isWeddingDressProperty() ? '请上传竖图' : '请上传方图')
    return
  }
  callback()
}

export const checkEmoji = (rule, value, callback) => {
  if (isEmojiCharacter(value)) {
    callback('禁止输入表情符号')
  }
  callback()
}

/**
 * @title 验证必选标签
 */
export const validateRequiredTags = list => {
  const tag_list = []
  const tag_list_parent_id = {}
  const require_tag_id = list
    .filter(tag => tag.required == 1)
    .map(tag => String(tag.id))

  for (let i = 0; i < list.length; i++) {
    for (let j = 0; j < list[i].children.length; j++) {
      if (list[i].children[j].isActive) {
        tag_list_parent_id[list[i].id] = list[i].id
        tag_list.push(list[i].children[j].mark_id)
      }
    }
  }

  const selected_items_parent_id = Object.keys(tag_list_parent_id).map(e =>
    String(e)
  )
  const isMatchAll = require_tag_id.every(id =>
    selected_items_parent_id.includes(id)
  )
  return { isMatchAll, tag_list }
}

/**
 * @title 验证案例详细信息
 */
export const validateCaseDetailInfo = async (details = [], checkWord) => {
  // 第一步验证，现场图设置不能小于5张大于50张
  const imageLength = details.filter(f => f.kind == 1).length
  const noSettingImage = details.filter(
    f => f?.kind == 1 && f?.imageAreaId == 0
  )
  if (noSettingImage.length) {
    return {
      check: false,
      msg: '案例详细信息含有未分区图片，请先将图片分区后提交'
    }
  }

  if (imageLength < 5 || imageLength > 50) {
    return {
      check: false,
      msg: '图片至少上传5张，最多可添加50张'
    }
  }
  // 第二步验证，若设计构思板块存在，则必填
  const designConcept = details.find(f => f.kind == 5)
  if (designConcept && !designConcept.content.text) {
    return { check: false, msg: '请输入设计构思后提交' }
  }
  const keywords = await checkWord(designConcept?.content?.text)
  if (keywords?.length) {
    return {
      check: false,
      msg: `设计构思中存在敏感 ${keywords.join(',')}，请检查后提交`
    }
  }
  // 第三步验证，若设计稿板块存在，但是没用图片，则校验必填
  const designDiagram = details.find(f => f.kind == 4)
  if (designDiagram && !designDiagram.content) {
    return { check: false, msg: '请上传设计稿后提交' }
  }
  return {
    check: true
  }
}

// 判断字符串为时间格式
export const isDateFormat = date => {
  if (!date) {
    return
  }
  return !isNaN(Date.parse(date))
}
